import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getReferralLeaderboard } from "@/lib/leaderboard.functions";

export const Route = createFileRoute("/leaderboard")({
  head: () => ({
    meta: [
      { title: "Referral leaderboard — The Hospitality Reserve" },
      { name: "description", content: "Top referrers on The Hospitality Reserve this month. Refer a bartender and earn £10 after their first shift." },
      { property: "og:title", content: "Referral leaderboard — The Hospitality Reserve" },
      { property: "og:url", content: "https://thehospitalityreserve.com/leaderboard" },
    ],
    links: [{ rel: "canonical", href: "https://thehospitalityreserve.com/leaderboard" }],
  }),
  component: LeaderboardPage,
});

function LeaderboardPage() {
  const fn = useServerFn(getReferralLeaderboard);
  const { data } = useQuery({ queryKey: ["ref-leaderboard"], queryFn: () => fn({}) });

  return (
    <main className="mx-auto max-w-2xl space-y-8 p-6">
      <header>
        <p className="text-[0.6rem] tracking-wide-luxury uppercase text-accent">Community</p>
        <h1 className="text-3xl font-medium">Referral leaderboard</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Top 10 members who brought in the most new bartenders and venues this month
          {data?.month ? ` — ${data.month}` : ""}.
        </p>
      </header>

      {!data || data.rows.length === 0 ? (
        <div className="border border-border p-8 text-center text-sm text-muted-foreground">
          No rewarded referrals yet this month. Be the first — share your referral link from your account page.
        </div>
      ) : (
        <ol className="border border-border">
          {data.rows.map((r) => (
            <li key={r.rank} className="flex items-center gap-4 border-b border-border p-4 last:border-b-0">
              <span className="w-8 text-lg font-medium tabular-nums text-accent">#{r.rank}</span>
              <span className="flex-1 text-sm">{r.display_name}</span>
              <span className="text-sm tabular-nums text-muted-foreground">
                {r.rewarded_count} referral{r.rewarded_count === 1 ? "" : "s"}
              </span>
            </li>
          ))}
        </ol>
      )}
    </main>
  );
}
